import { useEffect, useRef } from 'react'

export interface IdleWarningProps {
  open: boolean
  msUntilExpiry: number
  onExtend: () => void
  onSignOut: () => void
}

export function IdleWarning({ open, msUntilExpiry, onExtend, onSignOut }: IdleWarningProps) {
  const ref = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    const dialog = ref.current
    if (!dialog) return
    if (open && !dialog.open) dialog.showModal()
    if (!open && dialog.open) dialog.close()
  }, [open])

  const seconds = Math.max(0, Math.ceil(msUntilExpiry / 1000))

  return (
    <dialog
      ref={ref}
      aria-labelledby="idle-warning-title"
      onCancel={(event) => {
        event.preventDefault()
        onExtend()
      }}
      className="bg-surface m-auto w-full max-w-sm rounded-xl border p-6 shadow-xl backdrop:bg-gray-800/40"
    >
      <h2 id="idle-warning-title" className="text-text mb-2 text-base font-medium">
        Still there?
      </h2>
      <div
        role="status"
        aria-live="polite"
        className="text-text-2 mb-6 text-[12px] leading-relaxed"
      >
        You&rsquo;ll be signed out in {seconds} second{seconds === 1 ? '' : 's'} because of
        inactivity. This applies across Canopy and Trellis, which share one session.
      </div>
      <div className="canopy-save-row justify-end">
        <button type="button" className="canopy-btn" onClick={onSignOut}>
          Sign out now
        </button>
        <button type="button" className="canopy-btn canopy-btn-primary" onClick={onExtend}>
          Stay signed in
        </button>
      </div>
    </dialog>
  )
}
